export default __webpack_public_path__ + "static/media/weissstorch.05ebf81a.jpg";